<template>
				<main class="main-wrapper flex-grow-1 bg-documentGray" v-if="!hideThisScreen">
						<div class="d-flex align-items-center ">
							<div class="t-headline13 t-color-headlineBlack pda-14 t-center font-m flex-grow-1 bg-white fix-header-title d-flex align-items-center justify-content-center">
								{{this.$t("212")}}
							</div>
						</div>
						<div class="divider"></div>
						<!-- subtabs -->
						<top-app-bar-survey-list-tab></top-app-bar-survey-list-tab>
						<!-- <no-data v-if="isNoData==true"></no-data> -->
						<div class="container mgt-30">
								<!-- <img src="images/banner.svg" alt="" class="b-radius4"> -->
								<div v-if="campaignData && campaignData.locationValue === '0'">
									<a class="d-block" v-if="campaignData.dynamicLink" :href="campaignData.dynamicLink.shortLink" target="_blank">
										<img :src="campaignData.image" :alt="campaignData.dynamicLink.name" class="b-radius4 survey-banner" />
									</a>
									<a class="d-block"  v-else href="javascript:void(0)" target="_blank">
										<img :src="campaignData.image" alt="" class="b-radius4 survey-banner" />
									</a>
								</div>
								<no-data v-if="getSurveyCount(listData) < 1"></no-data>
								<!-- <div class="mgt-30 d-flex justify-content-between" v-if="totalSurveyCount > 0"> -->
								<div class="mgt-30 d-flex justify-content-between" v-if="getSurveyCount(listData) > 0">
										<div class="t-body6 t-color-bodyGrayA l-spacing45 t-line-h-22 font-r flex-grow-1">{{ $t("216", { str: getSurveyCount(listData) }) }}</div>
										<button class="material-icons mdc-icon-button test-list-toggler mgt--12 mgb--12 active" v-if="listType === 'card'">
											<img src="/images/survey/view-carousel.svg" 
												alt="" 
											/>
										</button>
										<button tabindex="0" @click="changeMode('card')" @keypress="changeMode('card')" class="material-icons mdc-icon-button test-list-toggler mgt--12 mgb--12 active" v-else>
											<img src="/images/survey/view-carousel-inactive.svg" 
												alt="" 
											/>
										</button>
										<button  v-if="listType === 'list'" 
											class="material-icons mdc-icon-button  test-list-toggler mgt--12 mgb--12 rtl-support active">
											view_list
										</button>
										<button  v-else
										@click="changeMode('list')" @keypress="changeMode('list')" tabindex="0"
											class="material-icons mdc-icon-button  test-list-toggler mgt--12 mgb--12 rtl-support">
											view_list
										</button>
								</div>
								<div class="divider mgt-16 mgb-16" v-if="getSurveyCount(listData) > 0"></div>
								<!-- <div class="d-flex justify-content-between align-items-baseline mgt-16 mgb-16">
										<div class="t-color-headlineBlack t-headline10 font-b t-line-h-33">시험 카테고리 1</div>
										<div class="t-color-secondaryBtnText t-body2 font-m t-line-h-22 l-spacing98">모두 보기</div>
								</div> -->
								<infinite-loading @infinite="fetchData" spinner="spiral">
									<div slot="no-more" class="pdt-10 pdb-16"></div>
									<div slot="no-results" class="pdt-10 pdb-16"></div>
								</infinite-loading>
						</div>
			<!-- {{listType}} -->
			
					<component
						:is="listType"
						:listData="listData"
						:campaignData="campaignData"
					></component>
					<!-- <infinite-loading @infinite="fetchData" spinner="spiral">
						<div slot="no-more" class="pdt-10 pdb-16"></div>
						<div slot="no-results" class="pdt-10 pdb-16"></div>
					</infinite-loading> -->
		</main>
</template>

<script>
/**
 * 단독 설문 전체 목록 메인 컴포넌트(independent survey total list main component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import surveyApi from "@/api/surveyApi.js";
import campaignApi from "@/api/campaignApi.js";
import { MDCRipple } from "@material/ripple";
import NoData from "../../common/NoDataSurveyListTotal.vue";
import TopAppBarSurveyListTab from "../../TopAppBarSurveyListTab.vue";
import InfiniteLoading from "vue-infinite-loading";
export default {
	name: "surveyTotal",
	components: {
		card: () => import("./TotalCard.vue"),
		list: () => import("./TotalList.vue"),
		NoData,
		InfiniteLoading,
		TopAppBarSurveyListTab
	},

	data() {
		return {
			listType: "card",
			isNoData: false,
			totalSurveyCount: 0,
			campaignData: null,
			listData: [],
			currentPage: 1,
			totalPages: 1,
			currentDate: Date.now(),
			hideThisScreen:false
		};
	},
	mounted() {
		if(this.$route.name === 'IndependentSurveyTotalView'){
			this.hideThisScreen = true;
		}
		else{
			this.hideThisScreen = false;
		}
		// 설문 총 갯수 API 호출(get survey total count)
		surveyApi.guestSurveyIndependentCount({ category: 1 }).then(() => {
			// this.totalSurveyCount = response.data.data
		});

		// 캠페인 테이터 API 호출(get campaign data)
		campaignApi
			.campaign({ locationType: "INDEPENDENT_SURVEY_LIST" })
			.then((response) => {
				this.campaignData = response.data.data;
			})
			.catch((err) => {});
	},

	updated() {
		// if( document.documentElement.scrollHeight > screen.availHeight){
		// 	var el = document.querySelector(".survey-hfull-class");
		// 	el.classList.remove('h-full');
		// }
		const ripples = [].map.call(
			document.querySelectorAll(".ripple-item"),
			function (el) {
				let ripple = new MDCRipple.attachTo(el);
				return ripple;
			}
		);
	},

	methods: {
		// Card / List 보기 모드 변경(change mode card/list)
		changeMode(mode) {
			this.listType = mode;
		},

		// 목록 데이터 호출(get exam list data)
		fetchData($state) {
			let responseData = null;
			let params = this.setParams();
			if (this.totalPages >= this.currentPage) {
				surveyApi
					.guestSurveyIndependentCategoryList(params)
					.then((response) => {
						let responseData = response.data.data;
						this.totalSurveyCount = responseData.content.length;
						this.listData = this.listData.concat(responseData.content);
						// this.listData.forEach((element,index) => {
						// 	console.log('element',element.surveys.length, index)
						// });
						
						// console.log('FFFF',this.listData)
						this.currentPage++;
						this.totalPages = responseData.totalPages;
						if (responseData.content.length) {
							$state.loaded();
						} else {
							$state.complete();
						}
						if (!this.listData.length) {
							this.isNoData = true;
						}
					//	console.log("this.listData", this.listData);
					});
			} else {
				$state.complete();
			}
		},

		// 파라미터 설정(set parameter)
		setParams() {
			const params = {
				itemCount: 10,
				page: this.currentPage,
				size: 10,
				sort: "id,desc",
			};
			return params;
		},
		getSurveyCount(listData) {
			let totalCount = 0;
			listData.forEach((cat) => {
				if (cat.surveys.length > 0) {
					cat.surveys.forEach((catInd) => {
						totalCount += 1;
					});
				}
			});
			//console.log('totalCount',totalCount)
			return totalCount;
		},
	},
};
</script>
<style type="text/css" scoped >
.swiper-button-next{
	right:2px !important;
}
.swiper-button-prev{
	left: 2px !important;
}
</style>